import type { OwaDate } from 'owa-datetime';
import { isAfter, isBefore } from 'owa-datetime';
import { owaDateFromGraphDate } from 'owa-graph-date';
import type { GetScheduleFlexibleWorkingHoursView } from 'owa-graph-schema';

/**
 * Filters FWH segments to only those that overlap with the given meeting time range.
 * Two ranges overlap when segmentStart < meetingEnd AND segmentEnd > meetingStart.
 */
export function getOverlappingFwhSegments(
    segments: GetScheduleFlexibleWorkingHoursView[],
    meetingStart: OwaDate,
    meetingEnd: OwaDate
): GetScheduleFlexibleWorkingHoursView[] {
    return segments.filter(segment => {
        const segmentStart = owaDateFromGraphDate(segment.start);
        const segmentEnd = owaDateFromGraphDate(segment.end);
        return isBefore(segmentStart, meetingEnd) && isAfter(segmentEnd, meetingStart);
    });
}
